export const discountAmount = (total, mode, value) => {
    const base = Math.max(0, Number(total) || 0);
    const amount = Math.max(0, Number(value) || 0);
    return Math.round((Math.min(base, mode === 'POURCENTAGE' ? base * Math.min(amount, 100) / 100 : amount) + Number.EPSILON) * 100) / 100;
};

export const documentDiscount = (values, total) => discountAmount(total, values.modeRemise, values.valeurRemise ?? values.montantRemise);
